
export const MenuKey = {
    quemSomos: 1,
    servicos: 2,
    galeria: 3,
    contato: 4
}